import React, {Fragment, useMemo} from "react";
import {observer} from "mobx-react";
import cx from 'classnames';

import {GameItem} from "../../../components";
import {toCamel} from "../../../common/utils";
import {JackpotGroupCard} from "./jackpot-group-card";

const GamesRender = ({ gamesType, list, jackpotGroups = [], itemsInRow, isCentered }) => {
    const getGroupByItemIndex = (i) => {
        const itemsWithCard = (itemsInRow - 1) * 2;
        if (jackpotGroups.length && i % itemsWithCard === 0) {
            const groupIndex = i / itemsWithCard;
            return jackpotGroups[groupIndex]
                ? { group: jackpotGroups[groupIndex], groupIndex }
                : null;
        } else {
            return null;
        }
    };

    const cameledList = useMemo(() => list.map(toCamel), [list]);

    /**************** RENDER ******************/
    return (
        <div className="game-list__group">
            <div
                className={cx(
                    'game-list__group-wrapper',
                    isCentered ? 'game-list__group-wrapper--centered' : null
                )}
            >
                <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
                    <filter id="killBlack" colorInterpolationFilters="sRGB">
                    <feColorMatrix type="matrix" values="
                        1 0 0 0 0
                        0 1 0 0 0
                        0 0 1 0 0
                        1 1 1 0 0"
                    />
                    </filter>
                </svg>
                {cameledList.map((item, i) => {
                    const groupByItemIndex = getGroupByItemIndex(i);
                    return (
                        <Fragment key={item.iD}>
                            {groupByItemIndex ? (
                                <JackpotGroupCard
                                    group={groupByItemIndex.group}
                                    index={groupByItemIndex.groupIndex}
                                />
                            ) : null}
                            <div className={`games__item`}>
                                <GameItem item={item} gamesType={gamesType} />
                            </div>
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default observer(GamesRender);
